import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'outline';
}

const Badge: React.FC<BadgeProps> = ({ className, variant = 'default', ...props }) => {
  const variants = {
    default: 'bg-[var(--admin-cyan-soft)] text-[var(--admin-cyan)]',
    success: 'bg-[var(--admin-emerald-soft)] text-[var(--admin-emerald)]',
    warning: 'bg-[var(--admin-amber-soft)] text-[var(--admin-amber)]',
    error: 'bg-[var(--admin-rose-soft)] text-[var(--admin-rose)]',
    outline: 'border border-[var(--admin-border)] bg-white/60 text-[var(--admin-muted)]',
  };

  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--admin-cyan)] focus:ring-offset-2',
        variants[variant],
        className
      )}
      {...props}
    />
  );
};

export default Badge;
